// 企业管理模块国际化 - 中文
export default {
  source: {
    upstreamRemoved: '上游已移除，保留手工账户关联',
    detailReadOnly: 'MDM 基础信息及地址只读；职责范围、默认和对账选择可在本地维护',
    label: '数据来源', manual: '手工', mdm: 'MDM', unknown: '来源未知', loading: '来源加载中',
    cargoware: 'CargoWare 同步', cargowareHint: '从 CargoWare 同步的数据',
    manualHint: '手工维护的数据可编辑', loadingHint: '企业来源确认前暂不可编辑',
    mdmReadOnly: 'MDM 同步数据仅可查看，请在源系统维护', unknownHint: '来源未标识或未识别，沿用现有维护权限',
    unavailable: '企业来源尚未读取成功，暂不可编辑，请重新加载',
    viewFull: '查看完整资料'
  },
  /** 发送方客商关系上的运价分享开关。 */
  rateShare: {
    title: '运价分享设置',
    enabled: '开通运价分享',
    on: '开',
    off: '关',
    tip: '开启后，本企业可向该客商分享运价。关闭后停止新的分享，已分享的运价保留。',
    confirmEnable: '确认向该客商开通运价分享？',
    confirmDisable: '确认关闭该客商的运价分享？已分享的运价将保留。',
    saved: '运价分享设置已保存',
    saveFailed: '运价分享设置保存失败',
    loadFailed: '运价分享设置加载失败',
    reload: '重新加载'
  },
  title: '企业管理',
  description: '管理企业信息、联系人、财务账户、对接人及运价等级',

  fields: {
    enterpriseName: '企业名称',
    enterpriseNameEn: '英文名称',
    enterpriseCode: '企业编码',
    businessLicense: '营业执照号',
    businessLicenseFile: '营业执照文件',
    address: '企业地址',
    addressDetail: '详细地址',
    remark: '备注',
    status: '企业状态',
    createTime: '创建时间',
    lastActive: '最后活跃',
    userCount: '用户数',
    industry: '所属行业',
    scale: '企业规模',
    contacts: '联系人',
    contactName: '联系人姓名',
    contactPosition: '联系人职位',
    contactPhone: '联系人电话',
    contactEmail: '联系人邮箱',
    ifDefault: '默认联系人',
    ifReconciliation: '对账联系人',
    invoiceInfo: '开票信息',
    cnyBankAccount: '人民币账户',
    usdBankAccount: '美金账户',
    dedicatedRelList: '企业对接人',
    freightLevelConfigList: '运价等级配置',
    businessType: '业务类型',
    freightLevel: '运价等级',
    action: '操作动作',
    enterpriseId: '企业ID',
    countryCode: '国家编码',
    provinceCode: '省编码',
    cityCode: '市编码',
    districtCode: '区编码',
    streetCode: '街道编码',
    enterpriseInfo: '企业信息',
    contactInfo: '联系信息',
    users: '用户',
    email: '企业邮箱',
    actions: '操作',
    auditResult: '审核结果',
    auditReason: '审核意见',
    audit: '审核',
    auditInfo: '待审核企业信息',
    businessLicenseFileName: '营业执照.jpg',
    uploadTime: '上传时间',
    unknown: '未知',
    addressCascader: '省市区街道',
    contactMethod: '联系方式',
    userId: '用户ID',
    userInfo: '用户信息',
    role: '角色',
    invoiceCompanyName: '公司名称',
    invoiceTaxNo: '税务登记号',
    invoiceAddress: '开票地址',
    invoicePhone: '开票电话',
    invoiceBank: '开户银行',
    invoiceBankAccount: '银行账号',
    cnyAccountInfo: '人民币账户',
    usdAccountInfo: '美金账户',
    reconciliationContactName: '联系人',
    reconciliationContactPosition: '职位',
    reconciliationContactPhone: '电话',
    reconciliationContactEmail: '邮箱',
    noReconciliationContact: '未设置对账联系人',
    cnyBankName: '银行名称',
    cnyBankAddress: '银行地址',
    usdBankName: '银行名称',
    usdBankAddress: '银行地址',
    cnyAccountName: '账户名称',
    cnySwiftCode: 'SWIFT代码',
    usdAccountName: '账户名称',
    usdSwiftCode: 'SWIFT代码',
    reconciliationContact: '对账联系人',
    coordinatorType: '类型',
    name: '姓名',
    phone: '手机号',
    reconciliationContactSelect: '选择对账联系人',
    contactPerson: '联系人',
    noAddress: '暂无地址'
  },

  status: {
    all: '全部状态',
    active: '正常',
    inactive: '已停用',
    pending: '待审核',
    rejected: '审核拒绝',
    unknown: '未知',
    approved: '审核通过'
  },

  actions: {
    addCompany: '添加企业',
    editCompany: '编辑企业',
    deleteCompany: '删除企业',
    viewDetail: '详情',
    refresh: '刷新',
    save: '保存',
    cancel: '取消',
    addContact: '添加联系人',
    editContact: '编辑联系人',
    setDefault: '设为默认',
    addCoordinator: '添加对接人',
    editCoordinator: '编辑对接人',
    addUser: '增加用户',
    editUser: '编辑用户',
    audit: '审核认证',
    enable: '启用',
    disable: '停用',
    search: '搜索',
    copy: '复制',
    upload: '上传',
    preview: '预览',
    replace: '替换',
    select: '选择',
    close: '关闭',
    back: '返回',
    more: '更多',
    edit: '编辑',
    viewUsers: '点击查看该企业的关联用户',
    deleteContact: '删除联系人',
    editFinancial: '编辑财务信息',
    setAdmin: '设置管理员',
    remove: '移除',
    copyFromCny: '从人民币账户复制',
    copyFromInvoice: '从开票信息复制',
    delete: '删除',
    pendingAuditInfo: '待审核企业信息',
    goBack: '返回',
    submit: '提交申请',
    saveEdit: '保存修改',
    update: '修改',
    confirm: '确认'
  },

  forms: {
    searchPlaceholder: '搜索企业名称、联系人',
    statusFilter: '状态筛选',
    nameRequired: '请输入企业名称',
    englishNameRequired: '请输入企业英文名称',
    businessLicenseRequired: '请输入营业执照号',
    businessLicenseInvalid: '请输入有效的营业执照号（18位数字和字母）',
    addressRequired: '请选择企业地址',
    detailAddressRequired: '请输入详细地址',
    contactNameRequired: '请输入联系人姓名',
    contactPhoneOrEmailRequired: '联系人电话和邮箱至少填写一项',
    contactPhoneInvalid: '请输入有效的联系电话',
    contactEmailInvalid: '请输入有效的邮箱地址格式',
    invoiceCompanyNameRequired: '请输入开票公司名称',
    invoiceTaxNoRequired: '请输入税务登记号',
    invoiceAddressRequired: '请输入开票地址',
    invoicePhoneRequired: '请输入开票电话',
    invoiceBankRequired: '请输入开户银行',
    invoiceBankAccountRequired: '请输入银行账号',
    cnyBankNameRequired: '请输入银行名称',
    cnyBankAccountRequired: '请输入银行账号',
    cnyAccountNameRequired: '请输入账户名称',
    cnySwiftCodeRequired: '请输入SWIFT代码',
    cnyBankAddressRequired: '请输入银行地址',
    reconciliationContactRequired: '请选择对账联系人',
    remarkPlaceholder: '请输入备注信息（可选）',
    auditResultPlaceholder: '请选择审核结果',
    auditReasonPlaceholder: '请详细说明审核的原因和意见',
    contactNameMax: '最多140个字符',
    contactNamePattern: '格式不正确',
    contactPositionMax: '最多140个字符',
    contactPositionPattern: '格式不正确',
    contactPhoneMax: '最多140个字符',
    contactPhonePattern: '格式不正确',
    contactEmailMax: '最多140个字符',
    contactEmailPattern: '格式不正确',
    invoicePhonePattern: '请输入正确的开票电话'
  },

  messages: {
    saveSuccess: '企业信息已保存',
    saveSuccessRefreshHint: '保存成功。若页面数据未更新，请刷新浏览器（需确认 enterprise-service、mdm-service 已启动）',
    saveFailed: '保存失败，请检查表单内容',
    deleteConfirm: '确定要删除这家企业吗？',
    deleteContent: '删除后 {name} 的所有信息将无法恢复',
    deleteSuccess: '企业 {name} 已删除',
    addContactSuccess: '联系人已添加',
    updateContactSuccess: '联系人信息已更新',
    deleteContactSuccess: '联系人已删除',
    setDefaultContactSuccess: '已设置为默认联系人',
    addCoordinatorSuccess: '对接人已添加',
    updateCoordinatorSuccess: '对接人信息已更新',
    deleteCoordinatorSuccess: '对接人已删除',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    aiFillSuccess: 'AI识别成功，已自动填充企业信息',
    auditSuccess: '企业审核已完成',
    auditFailed: '企业审核失败',
    refreshSuccess: '数据已刷新',
    copySuccess: '{label}已复制到剪贴板',
    auditResultRequired: '请选择审核结果',
    auditReasonRequired: '请输入审核意见',
    // index页面相关
    basicInfoValidationFailed: '基础信息验证失败',
    contactDataFailed: '联系人数据获取失败',
    financialInfoFailed: '财务信息数据获取失败',
    submitSuccess: '提交成功',
    operationFailed: '操作失败',
    getListFailed: '获取企业列表失败',
    getStatsFailed: '获取企业统计失败',
    statusChangeFailed: '企业状态修改失败',
    auditSuccessWithResult: '企业审核{result}成功',
    copyFail: '复制{label}失败'
  },

  tabs: {
    basicInfo: '基本信息',
    contacts: '联系人',
    contactsList: '联系人列表 ({count})',
    financialInfo: '财务信息',
    coordinator: '对接人',
    coordinatorList: '对接人列表（{count}）',
    rateLevel: '客户等级',
    relatedUsers: '关联用户',
    relatedUsersList: '关联用户（{count}）',
    thirdPartyAuth: '授权第三方系统',
    wtfInfo: 'WTF信息',
    roleConfig: '角色配置',
    mdmAttribute: '客商属性'
  },

  mdm: {
    import: 'MDM 客商导入',
    importResult: '导入完成：成功 {success} 条，失败 {fail} 条',
    importNoValidRows:
      '未识别到有效数据：请使用「下载模板」导出的文件，不要修改英文表头（mdmCode、enterpriseName 等），并至少填写一行',
    importFileTooLarge: '文件大小不能超过 10MB',
    importFailed: 'MDM 客商导入失败',
    downloadFailExcel: '下载失败明细',
    downloadFailExcelTip: '部分行导入失败，是否下载失败明细 Excel？',
    importFailFilename: 'mdm-customer-vendor-import-fail.xlsx',
    importTemplateFilename: 'mdm-customer-vendor-import-template.xlsx',
    templateDownloadFailed: '模板下载失败',
    shortName: '企业简称',
    legalRepresentative: '法定代表人',
    mdmReadOnlyTip: '由 MDM 同步，如需修改请走主数据系统',
    yes: '是',
    no: '否',
    partnerCustomer: '客户',
    partnerSupplier: '供应商',
    tenantOnlyTitle: '仅韶音租户可用',
    tenantOnlySubtitle: '请确认配置管理 custom.validation.enabled = shokz',
    page: {
      title: 'MDM 客商管理',
      subtitle: '韶音租户专用 · Excel 批量导入与客商属性查看',
      importCardTitle: '批量导入',
      importDesc: '上传 MDM 标准 Excel 模板（.xlsx / .xls，≤ 10MB），按 mdmCode 幂等 Upsert 客商数据。',
      downloadTemplate: '下载导入模板',
      selectExcelImport: '选择 Excel 导入',
      lastImport: '上次导入：成功 {success} 条，失败 {fail} 条',
      viewAttributeCardTitle: '查看客商 MDM 属性',
      enterpriseIdLabel: '企业 ID',
      enterpriseIdPlaceholder: '输入企业 ID',
      viewMdmAttribute: '查看 MDM 属性'
    },
    extensionPage: {
      title: '客商 MDM 属性',
      subtitle: '企业 ID: {id}',
      noData: '暂无 MDM 扩展数据',
      missingEnterpriseId: '缺少企业 ID',
      loadFailed: '加载 MDM 扩展信息失败'
    },
    attribute: {
      readOnlyAlert: 'MDM 来源字段为只读展示，变更请通过 MDM 主数据系统推送同步。',
      generalTitle: '通用属性',
      customerTitle: '客户属性',
      supplierTitle: '供应商属性',
      receivingTitle: '收货地址',
      noReceivingAddress: '暂无收货地址',
      receivingLoadFailed: '收货地址加载失败，请重试',
      addressTitle: '地址 {index}',
      primaryTag: '主要',
      mdmId: 'MDM ID',
      counterpartyCode: '相对方代号',
      counterpartyNature: '相对方性质',
      mainCurrency: '主要币别',
      cooperatingSubsidiary: '主要合作子公司',
      isInternalEntity: '是否内部主体',
      partnerTypes: '合作伙伴类型',
      country: '国家',
      provinceCity: '省/市',
      receivingCompany: '收货公司',
      detailAddress: '详细地址',
      contactName: '联系人',
      contactPhone: '联系电话',
      syncLogTitle: 'MDM 同步日志（最近 100 条）',
      syncTime: '推送时间',
      operationType: '操作类型',
      mdmCode: 'MDM编码',
      result: '结果',
      success: '成功',
      fail: '失败',
      errorMessage: '失败原因',
      customerId: '客户 ID',
      customerStatus: '客户状态',
      salesMode: '销售模式',
      customerCategory: '客户类别',
      regionLevelOne: '一级区域',
      regionLevelTwo: '二级区域',
      regionLevelThree: '三级区域',
      salesRepresentative: '销售代表',
      tradeTerms: '贸易条款',
      taxRate: '客户税率',
      isTemporarySupplier: '是否临时供应商',
      supplierStatus: '供应商状态',
      supplierPaymentDays: '供应商账期（天）',
      supplierTaxRate: '供应商税率',
      responsibleBusinessPerson: '负责业务人员'
    },
    bankAccount: {
      title: '银行账户',
      accountCount: '{count} 个账户',
      addAccount: '添加账户',
      currency: '币种',
      bankName: '开户银行',
      bankAccount: '银行账号',
      accountName: '账户名称',
      swiftCode: 'SWIFT',
      bankCountry: '银行国家',
      bankAddress: '银行地址',
      action: '操作',
      deleteAccount: '删除账户'
    }
  },

  breadcrumb: {
    platformAdmin: '平台运营后台'
  },

  stats: {
    totalCompanies: '总企业数'
  },

  tips: {
    rateLevel: '设置不同运价类型下，客户可见的运价等级。例如：海运整箱--T0，海运拼箱--T2'
  },

  modals: {
    licensePreview: '营业执照预览',
    noLicense: '暂无营业执照',
    uploadLicenseTip: '请先上传营业执照文件',
    uploadLicense: '上传营业执照',
    uploadLicenseReq: '上传要求：',
    uploadLicensePhoto: '• 请上传清晰的营业执照照片或扫描件',
    uploadLicenseFormat: '• 支持 JPG、PNG、PDF 格式',
    uploadLicenseSize: '• 文件大小不超过 10MB',
    uploadLicenseResolution: '• 建议图片分辨率不低于 1024×768',
    uploadLicenseDrag: '点击选择文件或拖拽到此处',
    uploadLicenseDragTip1: '将营业执照文件拖拽到此区域',
    uploadLicenseDragTip2: '或点击选择文件上传，AI将自动识别企业信息'
  },

  enum: {
    status: {
      pending: '待审核',
      active: '正常',
      rejected: '审核拒绝',
      disabled: '已停用'
    },
    dedicatedType: {
      operation: '专属操作',
      sales: '专属销售',
      service: '专属客服',
      document: '专属单证',
      business: '专属商务',
      finance: '专属财务'
    },
    freightLevel: {
      T0: 'T0等级',
      T1: 'T1等级',
      T2: 'T2等级',
      T3: 'T3等级'
    },
    businessType: {
      FCL: '海运整箱',
      LCL: '海运拼箱',
      AIR: '空运',
      RAIL: '铁路',
      PRECARRIAGE: '港前',
      LASTMILE: '尾程'
    },
    inviteStatus: {
      pendingJoin: '待加入',
      joined: '已加入',
      invalid: '作废',
      expired: '超时'
    },
    joinEnterpriseAuditStatus: {
      PENDING: '待审核',
      APPROVED: '审核通过',
      REJECTED: '审核拒绝'
    }
  },

  profile: {
    loading: '正在加载企业信息...',
    uncertifiedTitle: '尚未认证企业',
    uncertifiedDesc: '暂无法使用相关功能，请先认证或加入企业',
    certifyNewTitle: '认证新企业',
    certifyNewDesc: '提交认证资料，创建全新的企业账户，成为企业管理员',
    certifyNow: '立即认证',
    joinExistTitle: '加入已有企业',
    joinExistDesc: '通过企业邀请码或管理员邀请，加入已认证的企业组织',
    joinNow: '申请加入',
    bindThirdTitle: '绑定第三方租户',
    bindThirdDesc: '关联已有的第三方系统租户，保持同步企业信息和权限',
    bindNow: '开始绑定',
    pendingTitle: '企业认证审核中',
    pendingDesc: '您的企业认证申请正在审核中，预计1-3个工作日内完成审核',
    rejectedTitle: '企业认证审核拒绝',
    rejectedDesc: '很抱歉，您的企业认证申请未通过审核',
    resubmit: '重新提交认证',
    infoTitle: '企业信息',
    edit: '编辑',
    managementTitle: '员工管理',
    inviteTab: '邀请管理',
    applicationTab: '审核申请',
    inviteTabDesc: '生成邀请链接邀请员工加入企业，每个邀请链接有效期为48小时',
    applicationTabDesc: '审核用户主动提交的加入申请，通过审核后用户即可加入企业',
    inviteBtn: '邀请员工',
    inviteCode: '邀请码',
    inviteEmail: '邀请邮箱',
    inviteLink: '邀请链接',
    inviteStatus: '状态',
    inviteCreateTime: '创建时间',
    inviteExpireTime: '有效期至',
    inviteAction: '操作',
    inviteCancel: '作废',
    applicationUser: '用户信息',
    applicationInfo: '申请信息',
    applicationStatus: '状态',
    applicationAction: '操作',
    applicationPhone: '手机',
    applicationEmail: '邮箱',
    applicationTime: '申请时间',
    joinModalTitle: '加入企业',
    joinType: '加入方式',
    hasInviteCode: '有邀请码',
    noInviteCode: '无邀请码申请',
    inviteCodePlaceholder: '请输入邀请码',
    joinEnterpriseName: '企业名称',
    joinEnterpriseNamePlaceholder: '请输入要加入的企业名称',
    joinApplyMessage: '申请说明',
    bindModalTitle: '绑定第三方租户',
    thirdSystem: '第三方系统',
    thirdSystemPlaceholder: '请选择第三方系统',
    tenantId: '租户ID',
    tenantIdPlaceholder: '请输入第三方系统的租户ID',
    tenantName: '租户名称',
    tenantNamePlaceholder: '请输入租户名称',
    apiKey: 'API密钥',
    apiKeyPlaceholder: '请输入API密钥',
    remark: '备注',
    remarkPlaceholder: '可选的备注信息',
    inviteModalTitle: '邀请员工',
    sendMailBtn: '发送邀请',
    copy: '复制',
    inviteCodeLabel: '邀请码：',
    inviteLinkLabel: '邀请链接：',
    sendInviteMail: '发送邀请邮件',
    inviteMailPlaceholder: '请输入邮箱地址',
    joinSuccess: '已发起申请',
    joinApplySuccess: '加入申请已提交，请等待管理员审核',
    joinFail: '加入企业失败',
    bindSuccess: '第三方租户绑定成功',
    bindFail: '绑定第三方租户失败',
    generateInviteFail: '生成邀请链接失败',
    inviteMailSuccess: '邀请邮件发送成功',
    inviteMailFail: '邀请邮件发送失败',
    emailRequired: '请输入邮箱地址',
    inviteLinkRequired: '请先生成邀请链接',
    joinModalTip: '请选择您的加入方式，有邀请码可以直接加入，没有邀请码需要申请审核。',
    joinTypeRadioWithCode: '我有邀请码',
    joinTypeRadioNoCode: '我没有邀请码',
    joinInviteCodeLabel: '邀请码',
    joinInviteCodePlaceholder: '请输入企业邀请码',
    joinCompanyNameLabel: '企业全称',
    joinCompanyNamePlaceholder: '请输入完整的企业名称（需精确匹配）',
    joinApplyMessageLabel: '申请留言',
    joinApplyMessagePlaceholder: '请简要说明您申请加入该企业的理由',
    joinModalOk: '提交申请',
    joinModalCancel: '取消',
    infoCardTitle: '企业认证申请',
    infoCardStatusApproved: '审核通过',
    infoCardStatusRejected: '审核拒绝',
    infoCardStatusPending: '待审核',
    infoCardStatusUncertified: '未认证',
    infoCardCompanyName: '企业名称',
    infoCardCompanyNameEn: '英文名称',
    infoCardBusinessLicense: '营业执照号',
    infoCardSubmitTime: '申请时间',
    infoCardRejectReason: '审核拒绝原因',
    infoCardApprovedTip: '✅ 恭喜！企业认证已通过',
    infoCardApprovedDesc: '您的企业已成功认证，现在可以管理企业信息和邀请员工加入。',
    infoCardManageBtn: '企业信息管理',
    // 申请管理相关
    applicationUserName: '用户姓名',
    applicationUserPhone: '手机号码',
    applicationUserEmail: '邮箱地址',
    applicationApplyTime: '申请时间',
    applicationApproveBtn: '审核通过',
    applicationRejectBtn: '审核拒绝',
    applicationRejectModalTitle: '拒绝申请',
    applicationRejectModalWarning: '⚠️ 拒绝后该用户将无法通过此次申请加入企业，请谨慎操作。',
    applicationRejectModalApplicant: '申请人',
    applicationRejectModalReasonLabel: '拒绝原因',
    applicationRejectModalReasonPlaceholder: '请填写拒绝理由，将会通知申请人',
    applicationRejectModalOk: '确认拒绝',
    applicationRejectModalCancel: '取消',
    applicationRejectModalReasonRequired: '请填写拒绝原因',
    applicationApproveSuccess: '申请已审核通过',
    applicationRejectSuccess: '申请已拒绝',
    applicationRejectReasonRequired: '请填写拒绝原因',
    applicationRejectReason: '拒绝原因'
  },
  // 以下为新增国际化key，供企业认证相关tab使用
  basic: {
    status: '企业状态',
    pending: '待审核',
    enterpriseName: '企业名称',
    enterpriseNameRequired: '请输入企业名称',
    enterpriseNamePlaceholder: '请输入企业名称',
    enterpriseNameMaxLength: '企业名称最多70个中文字符（140个字符）',
    enterpriseNamePattern: '企业名称只能包含中文字符、数字、括号、逗号、引号、横杠、点号、空格',
    enterpriseNameEn: '英文名称',
    enterpriseNameEnRequired: '请输入企业英文名称',
    enterpriseNameEnPlaceholder: '请输入企业英文名称',
    enterpriseNameEnMaxLength: '英文名称最多140个字符',
    enterpriseNameEnPattern:
      '英文名称只能包含大小写英文字母、空格、逗号、点、括号、横杠、斜杠、数字、引号',
    businessLicense: '营业执照号',
    businessLicenseRequired: '请输入营业执照号',
    businessLicenseInvalid: '请输入有效的营业执照号（18位数字和字母）',
    businessLicensePlaceholder: '请输入18位营业执照号',
    businessLicenseMaxLength: '营业执照号最多30个字符',
    businessLicensePattern:
      '营业执照号只能包含大小写英文字母、空格、逗号、点、括号、横杠、斜杠、数字、引号',
    businessLicenseFile: '营业执照',
    businessLicenseFileRequired: '请上传营业执照文件',
    businessLicenseFileFormat: '只支持 JPG、PNG、PDF 格式',
    businessLicenseFileSize: '文件大小不能超过 10MB',
    remark: '备注',
    remarkMaxLength: '备注最多1000个字符',
    businessLicenseFileName: '营业执照.jpg',
    uploadTime: '上传时间',
    unknown: '未知',
    preview: '预览',
    replace: '替换',
    uploadLicense: '上传营业执照',
    country: '国家',
    countryRequired: '请选择国家',
    countryPlaceholder: '请选择国家',
    addressCascader: '企业地址（省市区街道）',
    province: '省份',
    provincePlaceholder: '请选择省',
    city: '市',
    cityPlaceholder: '请选择市',
    district: '区',
    districtPlaceholder: '请选择区',
    street: '街道',
    streetPlaceholder: '请选择街道',
    addressCascaderRequired: '请选择企业地址',
    addressCascaderPlaceholder: '请选择省、市、区、街道',
    detailAddress: '详细地址',
    detailAddressRequired: '请输入详细地址',
    detailAddressPlaceholder: '请输入详细地址',
    detailAddressMaxLength: '详细地址最多280个字符',
    detailAddressPattern:
      '详细地址只能包含中文、大小写英文字母、空格、逗号、点、括号、横杠、斜杠、数字、引号',
    remarkPlaceholder: '请输入备注信息（可选）',
    licensePreview: '营业执照预览',
    uploadLicenseModal: '上传营业执照',
    noLicense: '暂无营业执照文件',
    countryListError: '获取国家列表失败',
    countrySearchError: '国家搜索失败',
    filePreviewNotSupported: '此文件类型不支持预览',
    fileDownloaded: '文件已下载',
    fileDownloadFailed: '文件下载失败',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    close: '关闭',
    cancel: '取消',
    delete: '删除',
    deleteSuccess: '营业执照已删除',
    uploadLicenseReq: '上传要求：',
    uploadLicensePhoto: '• 请上传清晰的营业执照照片或扫描件',
    uploadLicenseFormat: '• 支持 JPG、PNG、PDF 格式',
    uploadLicenseSize: '• 文件大小不超过 10MB',
    uploadLicenseResolution: '• 建议图片分辨率不低于 1024×768',
    uploadLicenseDrag: '点击选择文件或拖拽到此处',
    uploadLicenseDragTip1: '将营业执照文件拖拽到此区域',
    uploadLicenseDragTip2: '或点击选择文件上传，AI将自动识别企业信息',
    aiRecognizing: 'AI识别中...',
    aiRecognizingDesc: '正在智能识别营业执照信息，请稍后',
    recognitionSuccess: '识别成功!',
    recognitionSuccessDesc1: '已成功识别营业执照信息',
    recognitionSuccessDesc2: '企业信息已自动填充到表单中'
  },
  contact: {
    basicInfo: '基础信息',
    enableResponsibilityScope: '启用职责范围',
    responsibilitySettings: '职责范围设置',
    listTitle: '联系人列表 ({count})',
    add: '添加联系人',
    edit: '编辑联系人',
    delete: '删除联系人',
    default: '默认',
    setDefault: '设为默认',
    setDefaultConfirmTitle: '确认设置默认联系人',
    setDefaultConfirm: '确定要将 {name} 设置为默认联系人吗？',
    currentDefault: '当前默认联系人 {name} 将被取消默认状态',
    notice: '注意：',
    deleteConfirmTitle: '确认删除联系人',
    deleteConfirm: '确定要删除联系人 {name} 吗？',
    deleteIrreversible: '此操作不可撤销，请谨慎操作',
    name: '联系人姓名',
    nameRequired: '请输入联系人姓名',
    namePlaceholder: '请输入联系人姓名',
    nameMaxLength: '联系人姓名最多140个字符',
    namePattern: '联系人姓名只能包含中文字符、大小写英文字母、数字、括号、逗号、引号、横杠',
    title: '联系人职位',
    jobTitle: '岗位',
    jobTitlePlaceholder: '请输入岗位',
    addressSection: '联系地址',
    addAddress: '添加地址',
    isShippingAddress: '发货地址',
    country: '国家/地区',
    province: '省/州',
    city: '城市',
    detailAddress: '详细地址',
    titlePlaceholder: '请输入联系人职位',
    titleMaxLength: '联系人职位最多140个字符',
    titlePattern: '联系人职位只能包含中文字符、大小写英文字母、数字、括号、逗号、引号、横杠',
    phone: '联系电话',
    phoneRequired: '请输入联系电话',
    phoneInvalid: '请输入有效的手机号',
    phonePlaceholder: '请输入手机号',
    phoneMaxLength: '联系电话最多140个字符',
    phonePattern: '联系电话格式不正确',
    email: '邮箱地址',
    emailRequired: '请输入邮箱地址',
    emailInvalid: '请输入有效的邮箱地址',
    emailPlaceholder: '请输入邮箱地址',
    emailMaxLength: '邮箱地址最多140个字符',
    emailPattern: '请输入有效的邮箱地址格式',
    phoneOrEmailRequired: '联系电话和邮箱地址至少填写一项',
    wechatWorkRpaGroupName: '企微群聊名称（RPA）',
    wechatWorkRpaGroupNamePlaceholder: '请输入企微群聊名称',
    wechatWorkRpaGroupNameMaxLength: '企微群聊名称最多255个字符',
    containerLoadType: '整拼类型',
    containerLoadTypePlaceholder: '请选择整拼类型（可多选）',
    containerLoadTypeMaxLength: '整拼类型最多500个字符',
    routeRange: '航线范围',
    routeRangePlaceholder: '请选择航线（可多选）',
    routeRangeMaxLength: '航线范围最多500个字符',
    loadingPortRange: '起运港范围',
    loadingPortRangePlaceholder: '请选择起运港（可多选）',
    loadingPortRangeMaxLength: '起运港范围最多500个字符',
    carrierRange: '船东范围',
    carrierRangePlaceholder: '请选择船东（可多选）',
    carrierRangeMaxLength: '船东范围最多500个字符',
    contactInfo: '联系人信息',
    contactMethod: '联系方式',
    action: '操作',
    confirm: '确定',
    cancel: '取消',
    confirmSetDefault: '确定设置',
    confirmDelete: '确定删除',
    updateSuccess: '联系人信息已更新',
    addSuccess: '联系人已添加',
    setDefaultSuccess: '已设置默认联系人',
    deleteSuccess: '联系人已删除',
    noContacts: '请至少添加一个联系人',
    noDefaultContact: '请设置一个默认联系人',
    formValidationFailed: '联系人表单验证失败',
    cannotDeleteReconciliation: '{name} 为对账联系人,请取消后再试',
    combinationConflict:
      '该联系人的整拼类型、航线范围、船东范围组合与联系人 {name} 冲突，请修改后重试'
  },
  financial: {
    invoiceInfo: '开票信息',
    copyAll: '复制全部',
    companyName: '公司名称',
    taxNumber: '税务登记号',
    invoiceAddress: '开票地址',
    invoicePhone: '开票电话',
    bankName: '开户银行',
    bankAccount: '银行账号',
    cnyAccount: '人民币账户',
    accountName: '账户名称',
    swiftCode: 'SWIFT代码',
    bankAddress: '银行地址：',
    usdAccount: '美金账户',
    reconciliationContact: '对账联系人',
    addInvoice: '添加开票信息',
    deleteInvoiceRow: '删除开票信息',
    contact: '联系人：',
    position: '职位：',
    phone: '电话：',
    email: '邮箱：',
    noReconciliationContact: '未设置对账联系人',
    edit: '编辑财务信息',
    invoiceInfoRequired: '开票信息（必填）',
    cnyAccountRequired: '人民币账户（必填）',
    usdAccountOptional: '美金账户（选填）',
    // 新增表单字段
    invoiceCompanyName: '公司名称',
    invoiceCompanyNameRequired: '请输入开票公司名称',
    invoiceCompanyNamePlaceholder: '请输入开票公司名称',
    invoiceCompanyNameMaxLength: '公司名称最多140个字符',
    invoiceCompanyNamePattern: '公司名称只能包含中文字符、数字、括号、逗号、引号、横杠',
    invoiceTaxNumber: '税务登记号',
    invoiceTaxNumberRequired: '请输入税务登记号',
    invoiceTaxNumberPlaceholder: '请输入税务登记号',
    invoiceTaxNumberPattern:
      '税务登记号只能包含大小写英文字母、空格、逗号、点、括号、横杠、斜杠、数字、引号，最长30个字符',
    invoiceAddressRequired: '请输入开票地址',
    invoiceAddressPlaceholder: '请输入开票地址',
    invoiceAddressMaxLength: '开票地址最多280个字符',
    invoiceAddressPattern: '开票地址只能包含中文字符、数字、括号、逗号、引号、横杠',
    invoicePhoneRequired: '请输入开票电话',
    invoicePhonePlaceholder: '请输入开票电话',
    invoicePhonePattern: '开票电话只能包含数字、括号、逗号、引号、横杠、加号，最长140个字符',
    invoiceBankName: '开户银行',
    invoiceBankNameRequired: '请输入开户银行',
    invoiceBankNamePlaceholder: '请输入开户银行',
    invoiceBankNameMaxLength: '开户银行最多140个字符',
    invoiceBankNamePattern: '开户银行只能包含中文字符、数字、括号、逗号、引号、横杠',
    invoiceBankAccount: '银行账号',
    invoiceBankAccountRequired: '请输入银行账号',
    invoiceBankAccountPlaceholder: '请输入银行账号',
    invoiceBankAccountPattern: '银行账号只能包含数字，最多30位',
    cnyBankName: '银行名称',
    cnyBankNameRequired: '请输入银行名称',
    cnyBankNamePlaceholder: '请输入银行名称',
    cnyBankNameMaxLength: '银行名称最多140个字符',
    cnyBankNamePattern: '银行名称只能包含中文字符、数字、括号、逗号、引号、横杠',
    cnyBankAccount: '银行账号',
    cnyBankAccountRequired: '请输入银行账号',
    cnyBankAccountPlaceholder: '请输入银行账号',
    cnyBankAccountPattern: '银行账号只能包含数字，最多30位',
    cnyAccountName: '账户名称',
    cnyAccountNameRequired: '请输入账户名称',
    cnyAccountNamePlaceholder: '请输入账户名称',
    cnyAccountNameMaxLength: '账户名称最多140个字符',
    cnyAccountNamePattern: '账户名称只能包含中文字符、数字、括号、逗号、引号、横杠',
    cnySwiftCode: 'SWIFT代码',
    cnySwiftCodeRequired: '请输入SWIFT代码',
    cnySwiftCodePlaceholder: '请输入SWIFT代码',
    cnySwiftCodePattern: 'SWIFT代码只能包含大写字母、数字、短横杠',
    cnyBankAddress: '银行地址',
    cnyBankAddressRequired: '请输入银行地址',
    cnyBankAddressPlaceholder: '请输入银行地址',
    cnyBankAddressMaxLength: '银行地址最多280个字符',
    cnyBankAddressPattern: '银行地址只能包含中文字符、数字、括号、逗号、引号、横杠',
    usdBankName: '银行名称',
    usdBankNamePlaceholder: '请输入银行名称',
    usdBankNameMaxLength: '银行名称最多140个字符',
    usdBankNamePattern:
      '银行名称只能包含大小写英文字母、空格、逗号、点、括号、横杠、斜杠、数字、引号',
    usdBankAccount: '银行账号',
    usdBankAccountPlaceholder: '请输入银行账号',
    usdBankAccountPattern: '银行账号只能包含数字，最多30位',
    usdAccountName: '账户名称',
    usdAccountNamePlaceholder: '请输入英文账户名称',
    usdAccountNameMaxLength: '账户名称最多140个字符',
    usdAccountNamePattern:
      '账户名称只能包含大小写英文字母、空格、逗号、点、括号、横杠、斜杠、数字、引号',
    usdSwiftCode: 'SWIFT代码',
    usdSwiftCodePlaceholder: '请输入SWIFT代码',
    usdSwiftCodePattern: 'SWIFT代码只能包含大写字母、数字、短横杠',
    usdBankAddress: '银行地址',
    usdBankAddressPlaceholder: '请输入银行地址',
    usdBankAddressMaxLength: '银行地址最多280个字符',
    usdBankAddressPattern:
      '银行地址只能包含大小写英文字母、空格、逗号、点、括号、横杠、斜杠、数字、引号',
    reconciliationContactSelect: '选择对账联系人',
    reconciliationContactRequired: '请选择对账联系人',
    reconciliationContactSelectPlaceholder: '请选择对账联系人',
    copyFromCnyToInvoice: '从人民币账户复制',
    copyFromInvoiceToCny: '从开票信息复制',
    save: '保存',
    cancel: '取消',
    copySuccess: '{label}已复制到剪贴板',
    copyFailed: '复制失败，请手动复制',
    cnyAccountInfo: '人民币账户信息',
    usdAccountInfo: '美金账户信息',
    copyFromInvoiceToCnySuccess: '已复制开票信息到人民币账户',
    copyFromCnyToInvoiceSuccess: '已复制人民币账户信息到开票信息',
    saveSuccess: '财务信息已保存',
    saveFailed: '请检查财务信息填写是否正确',
    formValidationFailed: '财务表单验证失败',
    invoiceInfoIncomplete: '请完善开票信息',
    cnyAccountIncomplete: '请完善人民币账户信息'
  },
  relatedUser: {
    add: '新增用户',
    thirdPartySync: '第三方同步',
    detail: '详情',
    setAdmin: '设置管理员',
    remove: '移除',
    superAdmin: '超级管理员',
    user: '普通用户',
    syncTitle: '第三方用户同步',
    selectSystem: '请选择已授权的第三方系统',
    erp: 'ERP系统',
    wms: 'WMS系统',
    oms: 'OMS系统',
    startSync: '开始同步',
    cancel: '取消',
    syncing: '正在同步用户数据，请稍候...',
    syncingDesc: '预计需要5秒钟完成同步',
    syncSuccess: '用户同步完成',
    addUserDev: '添加用户功能开发中...',
    viewUserDetail: '查看用户详情: {name}',
    setAdminSuccess: '已将{name}设置为管理员',
    removeUserSuccess: '已移除用户: {name}',
    openSyncModal: '打开第三方同步弹窗',
    syncComplete: '第三方用户同步完成',
    addUserModalTitle: '新增用户',
    addUserModalDesc: '请从下列用户中选择要添加到企业的用户：',
    confirmAdd: '确定添加',
    selectedCount: '已选择 {count} 个用户',
    email: '邮箱',
    phone: '手机号',
    contact: {
      email: '邮箱',
      phone: '手机号'
    },
    status: '状态',
    lastLogin: '最后登录',
    id: 'ID',
    noAvailableUser: '暂无可选用户',
    avatar: '用户头像',
    setAdminModalTip:
      '每家租户只能有一个超级管理员，设置 {name} 为超级管理员后，原先的超级管理员将被撤销，改为普通用户权限。',
    setAdminModalWarning: '⚠️ 此操作将影响企业内用户的权限分配，请谨慎操作。',
    removeUserConfirmTitle: '移除用户确认',
    removeUserConfirmTip: '确定要移除用户 {name} 吗？',
    removeUserConfirmNotice: '注意',
    removeUserConfirmDesc: '移除后该用户将无法访问该企业的相关功能，此操作不可撤销。',
    confirmRemove: '确定移除'
  },
  coordinator: {
    tabTitle: '对接人列表（{count}）',
    add: '添加对接人',
    addEdit: '新增对接人',
    edit: '编辑对接人',
    type: '类型',
    name: '姓名',
    phone: '手机号',
    email: '邮箱',
    action: '操作',
    editAction: '编辑',
    deleteAction: '删除',
    selectTypePlaceholder: '请选择对接类型',
    typeLabel: '对接类型',
    staffLabel: '员工',
    selectStaffPlaceholder: '请选择员工',
    cancel: '取消',
    confirm: '确定',
    duplicateTypeError: '已存在相同类型的对接人',
    typeRequired: '请选择对接类型',
    staffRequired: '请选择员工'
  },
  rateLevelTab: {
    desc: '设置不同运价类型下，客户可见的运价等级。例如：海运整箱--T0，海运拼箱--T2'
  },
  roleConfig: {
    assignedRolesTitle: '已分配角色（{count}）',
    atLeastOneRole: '至少需要保留一个角色',
    saveRoleRequired: '请先在「角色配置」中至少添加一个企业角色后再保存',
    addRole: '添加角色',
    selectRole: '选择角色',
    addAll: '全部添加',
    cancel: '取消',
    add: '添加',
    roleAddedSuccess: '已添加 {count} 个角色',
    roleRemovedSuccess: '{name} 角色已移除',
    allRolesAssigned: '所有可用角色都已分配',
    configDescription: '💡 角色配置说明：',
    configTip1: '• 每个企业至少需要配置一个角色',
    configTip2: '• 可以从角色权限管理中选择已有角色进行分配',
    configTip3: '• 角色权限由系统管理员在角色权限管理中统一配置',
    configTip4: '• 企业用户将根据分配的角色获得相应的系统权限',
    noRoles: '暂无分配角色，请点击"添加角色"进行配置',
    createTime: '创建时间：',
    loadRolesError: '获取可用角色列表失败'
  }
}
